import { IState } from "@/redux/store.types";
import { getValueState } from "@/redux/utils";

import { $PaintFamiliesModuleName } from "./paintFamilies.types";

const getPaintFamilies = (state: IState) => {
    return getValueState(state, $PaintFamiliesModuleName)?.families;
};

export { getPaintFamilies };
